import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { MedicalAppointmentAudintingSearchItem } from "src/app/model/medical-appointment-auditing/medical-appointment-auditing-search-item";

@Component({
  selector: "app-medical-appointment-auditing-other-dialog",
  templateUrl: "./medical-appointment-auditing-other-dialog.component.html",
  styleUrls: ["./medical-appointment-auditing-other-dialog.component.css"],
})
export class MedicalAppointmentAuditingOtherDialogComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<MedicalAppointmentAuditingOtherDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: MedicalAppointmentAudintingSearchItem[]
  ) {}

  ngOnInit() {}

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  audit(item: MedicalAppointmentAudintingSearchItem): void {
    this.dialogRef.close(item);
  }
}
